import ProgressBar from '@frontend/jetlend-web-ui/src/ui/ProgressBar/ProgressBar';
import React from 'react';
import { formatPercentExt } from '@frontend/jetlend-core/src/formatters/formatUtils';
import Tooltip from '@frontend/jetlend-web-ui/src/ui/TooltipIcon/Tooltip';
import Link from 'next/link';
import Image from '@app/components/Image/Image';
import {
    IAchievementsMapResult,
    ICourseInformationApiModel,
    IUserCoursesItemApiModel,
} from '@app/models/features/course';
import { getEstimatedMinutes } from '@app/features/academy/academy.helper';

import styles from './CoursesBlock.module.scss';

export interface IProps {
    /**
     * Информация о курсе
     */
    course: ICourseInformationApiModel;
    /**
     * Информация о курсе пользователя
     */
    state: IUserCoursesItemApiModel;
    /**
     * Список ачивок
     */
    achievementsMap: IAchievementsMapResult;
}

/**
 * Функция для получения текущего прогресса по курсу
 * @param currentProgress - текущий прогресс
 * @param maxProgress - максимальный прогресс
 */
const getCourseProgress = (currentProgress: number, maxProgress: number) => {
    if (maxProgress <= 0) {
        return 0;
    }

    const progress = currentProgress/maxProgress;

    return isNaN(progress) ? 0 : progress;
};

/**
 * Блок карточки курса
 */
const CoursesBlockItem:React.FC<IProps> = props => {
    const {
        course,
        achievementsMap,
        state,
    } = props;
    const achievementInfo = achievementsMap?.[course?.achievement_id];
    const courseIcon = achievementInfo?.icon;
    const achievementTitle = achievementInfo?.title;

    return (
        <Link
            href={`/academy/courses/${course?.slug}`}
            key={course?.id}
            className={styles['wrapper']}
        >
            <div className={styles['top']}>
                <div className={styles['label']}>{course?.title}</div>
                {courseIcon && (
                    <Tooltip title={achievementTitle}>
                        <div className={styles['image']}>
                            <Image src={courseIcon} alt="" fill />
                        </div>
                    </Tooltip>
                )}
            </div>
            <ProgressBar
                darkGrey
                size="small"
                hideLabel
                type="success"
                progress={getCourseProgress(state?.passed_blocks_count, course?.blocks_count)}
            />
            <div className={styles['progress-block']}>
                <span>Пройдено {state?.passed_blocks_count ?? 0}/{course?.blocks_count} ({getEstimatedMinutes(state?.passed_estimated_time)})</span>
                <span>{formatPercentExt(getCourseProgress(state?.passed_blocks_count, course?.blocks_count))}</span>
            </div>
            <div className={styles['result-block']}>
                <span>{`${state?.mark ?? 0}/${course?.total_mark ?? 0}`}</span>
                &nbsp;
                <span>набрано баллов</span>
            </div>
        </Link>
    );
};

export default CoursesBlockItem;